const DOWNLOAD_MONETIZED_GOALS = {
  secondDl: {
    yandex: "second-dl",
    opera: "second-dl-o",
  },
  contentLockDownloadBrowser: {
    yandex: "download-content-lock-yandex-browser",
    opera: "download-content-lock-opera-browser",
  },
  contentLockInstallation: {
    yandex: "download-content-lock-yandex-browser-inst",
    opera: "download-content-lock-opera-browser-inst",
  },
  contentLockDownloadTargetContentOnTimeout: {
    yandex: "download-content-lock-yandex-browser-inst-on-timeout",
    opera: "download-content-lock-opera-browser-inst-on-timeout",
  },
  openContentLock: {
    yandex: "open-content-lock-yandex",
    opera: "open-content-lock-opera",
  },
  bannerButton: {
    yandex: "click-banner-button-yandex",
    opera: "click-banner-button-opera",
  },
};

module.exports = DOWNLOAD_MONETIZED_GOALS;